/**
 * region for libraries*/
import React, { Component } from "react";
import { Toolbar } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";

/**
 * region for components*/ 
 import HeaderTitle from '../../components/common/HeaderTitle';

/**  
 * region for redux*/
import { connect } from "react-redux";

/**
 * region for styles*/
import { Fragment } from "react";
class HeaderCrawlers extends Component {
  render() {
    let loadingIsActive = false;
    if (this.props.pending) {
      loadingIsActive = true;
    } else {
      loadingIsActive = false;
    }
    return (
      <Fragment>
        <Toolbar>
          <HeaderTitle
            title={"Crawlers Reports"} />
        </Toolbar>
        <Backdrop open={loadingIsActive}>
          <CircularProgress color="primary" />
        </Backdrop>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const pending = state.RssCrawlResultReducers.pending;
  return {
    pending,
  };
}

export default connect(mapStateToProps)((HeaderCrawlers));
